import { render } from "./ImageCarousel.vue?vue&type=template&id=5d989884&scoped=true"
import script from "./ImageCarousel.vue?vue&type=script&lang=js"
export * from "./ImageCarousel.vue?vue&type=script&lang=js"

import "./ImageCarousel.vue?vue&type=style&index=0&id=5d989884&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d989884"]])

export default __exports__